import { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { MaterialTransferido } from '@/shared/interfaces';

export type ModalAnalisisProductosAComprarProps = {
  open: boolean;
  productos: MaterialTransferido[];
  onClose: () => void;
  onConfirm: () => void;
}

export default function ModalAnalisisProductosAComprar({
  open,
  productos,
  //onClose,
  onConfirm,
}: ModalAnalisisProductosAComprarProps) {
  const [countdown, setCountdown] = useState(3);
  const timerRef = useRef<ReturnType<typeof setInterval>>();
  const calledRef = useRef(false)

  useEffect(() => {
    if (!open) {
      setCountdown(3);
      calledRef.current =false
      return;
    }
    timerRef.current=setInterval(()=>{
      setCountdown((prev)=>prev - 1);
    },1000);
    return ()=>clearInterval(timerRef.current);
  }, [open]);

  useEffect(()=>{
     if(countdown >0 || !open || calledRef.current) return;
     calledRef.current = true
     onConfirm();
  },[countdown, open, onConfirm])

  const totalUnidades = productos.reduce((sum, p) => sum + Number(p.cantidad_pendiente), 0);

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 2 } }}
    >
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={2}
          py={2}
        >
          <ShoppingCartIcon sx={{ fontSize: 64, color: 'primary.main' }} />
          <Typography variant="h6" textAlign="center" fontWeight="bold">
            Se va a realizar una solicitud de compra
          </Typography>
          <Typography variant="body1" textAlign="center" color="text.secondary">
            Total <strong>{productos.length}</strong> producto{productos.length !== 1 ? 's' : ''} (<strong>{totalUnidades}</strong> unidades) seleccionado{productos.length !== 1 ? 's' : ''} para comprar.
          </Typography>
          <Typography variant="h3" fontWeight="bold" color="primary">
            {countdown}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
